module.exports = __webpack_public_path__ + "images/53a4745d.main-pic-usa.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/main-pic-usa.png
// module id = 393
// module chunks = 0